var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href ? 'a' : 'button',{tag:"component",class:{
    button: true,
    disabled: _vm.disabled,
    small: _vm.small,
  },attrs:{"type":_vm.type,"href":_vm.href}},[_c('span',{staticClass:"button-title"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }